import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Stack } from '@mui/system';


function AgeFilterPills({setAgeGroups, ageGroups}) {
  
    const handleChange = (event, newAge) => {
        console.log(newAge, newAge)
      if (newAge !== null) {
        setAgeGroups(newAge);
      }
    };

  return (
    <ToggleButtonGroup
    value={ageGroups}
    exclusive
    onChange={handleChange}
    aria-label="text alignment"
  >
  
    <ToggleButton value="All" aria-label="All">
      Any age group
    </ToggleButton>
    <ToggleButton value="7+" aria-label="7+">
      7+
    </ToggleButton>
    <ToggleButton value="12+" aria-label="12+">
      12+
    </ToggleButton>
    <ToggleButton value="16+" aria-label="16+">
      16+
    </ToggleButton>
    <ToggleButton value="18+" aria-label="18+">
      18+
    </ToggleButton>

  </ToggleButtonGroup>
  )
}

export default AgeFilterPills